<template>
  <div class="nav-common-wrapper">
    <div
      v-for="(item, index) in menuList"
      :key="index"
      class="nav-common-item"
      @click="toPage(item)"
    >
      <img :src="item.icon" style="width: 70px; height: 70px" />
      <div style="font-size: 18px; color: #3f3f3f 100%">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    currentNavIndex: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {};
  },
  methods: {
    toPage(item) {
      console.log(item.path, '88888888')
      sessionStorage.setItem("currentNavIndex", this.currentNavIndex);
      // let text = this.$router.resolve({
      //   path: item.path,
      // });
      window.open(item.path, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.nav-common-wrapper {
  display: flex;
  justify-content: center;
  padding: 34px 0;
  .nav-common-item {
    height: 112px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 35px;
    cursor: pointer;
  }
  .nav-common-item:hover {
    color: #ec671a;
  }
}
</style>



// WEBPACK FOOTER //
// navCommon.vue?963dbaa6